import axios from "axios";
import { api } from "../../api";
// add order
export const addOrder = (data) => async (dispatch) => {
  dispatch({ type: "ORDER_SET_LOADER" });
  try {
    const response = await axios.post(
      `${api}/api/v2/add-order`,
      data
    );
   

    dispatch({
      type: "ORDER_ADD_SUCCESS",
      payload: {
        successMessage: response.data.success
      },
    });
  } catch (error) {
    console.log(error.response)
    dispatch({
      type: "ORDER_ADD_FAIL",
      payload: error.response.data.error.errorMessage
    });
  }
};



// get all order by pagination

export const getALlOrdersByPagination = (page) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${api}/api/v2/get-orders-by-pagination?page=${page}`
      );

    dispatch({
      type: "PERPAGE_ORDER_GET_SUCCESS",
      payload: {
        allOrder: response.data.allOrder,
        parPage: response.data.parPage,
        orderCount: response.data.orderCount,
      },
    });
  } catch (error) {
    console.log(error.response)
  }
};



// delete user

export const deleteOrder= (id) => async (dispatch) => {

  try {
    const response = await axios.delete(`${api}/api/v2/delete-order/${id}`);
  
    dispatch({
      type: "ORDER_DELETE_SUCCESS",
      payload:response.data.success
    });
  } catch (error) {
    console.log(error.response);
  }
};